module.exports = __webpack_public_path__ + "static/media/kavita.0fc2166f.svg";